import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PagePerformanceAdminRoutingModule } from './admin-routing.module';
import { AdminPagePerformanceProfilesComponent } from './profiles/profiles.component';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { LayoutModule, MonEventTriggerModule, MonTableSortModule, TableModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        AdminPagePerformanceProfilesComponent,
    ],
    imports: [
        FormsModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        UIRouterModule,
        PagePerformanceAdminRoutingModule,
        SharedModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        MonEventTriggerModule,
        MonTableSortModule,
    ],
    providers: [],
})
export class PagePerformanceAdminModule {}
